import React from 'react'
import { _SettingButton } from '../Data/Modals/SettingsModal/SettingsModal'
import RenderDataModal from '../Data/Modals/RenderViewModal/RenderViewModal'

export const FLEET_MANAGER_AUTO_SELECT_ALL_PREF = 'fleetManagerAutoSelectAll'

export interface DeviceUpdatesSettingsModalProps {
  onClose: () => void
}

const DeviceUpdatesSettingsModal: React.FC<DeviceUpdatesSettingsModalProps> = ({
  onClose
}) => {
  return (
    <RenderDataModal onClose={onClose} title="Settings" className="settings-modal">
      <_SettingButton name={FLEET_MANAGER_AUTO_SELECT_ALL_PREF}>
        When visiting Fleet Manager, select all organizations and fleets and run
        the search automatically.
      </_SettingButton>
    </RenderDataModal>
  )
}

export default DeviceUpdatesSettingsModal
